"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = CheckboxGroup;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("../styled-components");
const Layout_1 = require("../Layout");
const Checkbox_1 = require("../Primitives/Checkbox");
const util_1 = require("../util");
const Wrapper = styled_components_1.styled.div `
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;
const CheckWrapper = styled_components_1.styled.div `
  flex: 0 0 auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;
function CheckboxGroup(props) {
    var _a;
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    function getDisplayText(type) {
        const key = props.getTranslationKey
            ? props.getTranslationKey(type)
            : `label-${type}`;
        // @ts-ignore
        return i18n.exists(key)
            ? // @ts-ignore
                t(key)
            : type;
    }
    return (react_1.default.createElement(Wrapper, { style: { padding: (_a = props.padding) !== null && _a !== void 0 ? _a : "0px" } }, props.types.map((type, index) => {
        const inputId = "cbx_" + (0, util_1.uniqueID)();
        return (react_1.default.createElement(react_1.default.Fragment, { key: type },
            react_1.default.createElement(CheckWrapper, null,
                react_1.default.createElement(Checkbox_1.Checkbox, { name: type, key: type, id: inputId, checked: props.activeTypes.includes(type), autoFocus: props.autoFocus && index === 0, onChange: () => props.activeTypes.includes(type)
                        ? props.deselect(type)
                        : props.select(type) }),
                react_1.default.createElement(Layout_1.FlexSpace, { size: 6 }),
                react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: inputId }, getDisplayText(type))),
            react_1.default.createElement(Layout_1.FlexSpace, null)));
    })));
}
//# sourceMappingURL=index.js.map